import {
  formatDateTime,
  getDateFromDateAndTime,
} from "../../../common/utils/dates/dateUtils";

export const formatSailingLinkText = (
  {
    departureDate,
    departureTime,
  }: { departureDate: string; departureTime: string },
  routeCode: string,
  dateFormat: string,
): string => {
  const dateTime = getDateFromDateAndTime(departureDate, departureTime);

  return `${routeCode} ${formatDateTime(dateTime, dateFormat)}`;
};
